<template lang="html">

  <footer class="footer">

    <div class="top container row-between">



      <div class="bottom">

        <div class="logos-footer">
          <div class="bottom-links blanco row-between">
            <a href="https://portalcarrerasprofesionales.ufv.es/login " rel="noreferrer" target="_blank" class="btn -skull">Portal Carreras Profesionales</a>

          </div>
          <div class="bottom-links blanco row-between">
            <a target="_blank" rel="noreferrer" href="https://www.ufv.es/" class="btn -skull">Web UFV</a>

          </div>
          <div class="bottom-links blanco row-between rrss">

            <a target="_blank" rel="noreferrer" href="https://twitter.com/ufvmadrid"><img class="twitter" src="/static/img/twitter.svg"></a>
            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/UFVmadrid/" class="facebook"><img src="/static/img/facebook.svg"></a>
            <a target="_blank" rel="noreferrer"
              href="https://www.linkedin.com/school/universidad-francisco-de-vitoria-/"><img class="linkedin" src="/static/img/linkedin.svg"></a>
            <a target="_blank" rel="noreferrer" href="https://www.youtube.com/user/ufvmadrid" class="youtube"> <img style="width: 18px;"
                src="/static/img/yout.png" ></a>

          </div>


        </div>
      </div>

      <!--

      <div class="right">

        <div class="contenedor-input">
          <input type="text" placeholder="Email" v-validate="'required|email'" name="email" v-model="data.email">
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
        </div>
        <div class="contenedor-check">
          <input type="checkbox" id="politica-newsletter" name="politica" v-validate="'required'" v-model="politica">
          <label for="politica-newsletter">Acepto la <a target="_blank" rel="noreferrer" href="https://www.ufv.es/politica-de-privacidad/">política de privacidad</a></label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
        </div>

        <a @click="send" class="btn -skull" v-if="!!!enviado">Suscríbete a nuestra newsletter</a>  </div>-->
      <h3 v-if="enviado" class="enviado">Enviado</h3>
  

    </div>
    
    <div class="middle container row-center">

      <img src="/static/img/logo-gris.png" class="logo-gris" alt="Logo UFV">

      <div class="contenedor-uni">
        <img src="/static/img/foto--uni.svg" class="foto-uni" alt="Imagen de la universidad">
      </div>


    </div>

    <div class="bottom">
      <p>2024 © - Universidad Francisco de Vitoria</p>


      <nav class="bottom-links row-between">
        <a target="_blank" rel="noreferrer" href="https://www.ufv.es/aviso-legal/" style="margin-left:0px">Aviso
          legal</a>
        <a target="_blank" rel="noreferrer" href="https://www.ufv.es/politica-de-privacidad/">Política de privacidad</a>
        <a target="_blank" rel="noreferrer" href="https://www.ufv.es/politica-de-cookies/">Política de cookies</a>
        <router-link :to="$t('enlaces.contacto')" style="margin-right: -10px">Contacto</router-link>
      </nav>

    </div>

    <button class="cky-banner-element">Configuración Cookies</button>

  </footer>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex'

import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

export default {
  name: 'app-footer',
  data() {
    return {
      data: {
        email: ''
      },
      clicked: false,
      enviado: false,
      politica: false
    }
  },
  computed: {
    ...mapGetters({
      version: 'getVersion'
    })
  },
  methods: {
    ...mapActions(['sendNewsletter']),
    send() {

      this.clicked = true;
      this.$validator.validateAll().then(canSend => {
        if (canSend) {
          this.sendNewsletter(this.data).then(r => {
            if (r) {
              this.data.email = '';
              this.enviado = true;
              this.clicked = false;
              this.politica = false;
            }
          });
        }
      });



    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/parts/footer.vue